import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -15,
    government: -10,
    office: -15,
  },
  education: {
    childcare: -10,
    high_school: -5,
    library: 0,
    primary: -5,
    university: 0,
  },
  essentials: {
    electricity: 15,
    gas: 10,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 15,
    fast_food: 10,
    restaurant: 12,
  },
  health: {
    clinic: 5,
    dentist: 0,
    hospital: 5,
    pharmacy: 5,
  },
  nature: {
    beach: -5,
    forest: 10,
    lake: 5,
    mountain: 15,
    park: 10,
    river: 5,
  },
  religion: {
    church: 5,
    mosque: 5,
  },
  shops: {
    grocery: 10,
    mall: 15,
  },
  soil: {
    clay: 5,
    loam: 10,
    peat: 10,
    salt: 15,
    sand: -5,
    silt: 5,
  },
  sport: {
    gym: 5,
    pool: 0,
  },
  telecom: {
    cable_tv: 15,
    fiber_optic: 15,
    network_4g: 10,
    network_5g: 7,
    phone: 10,
  },
  transport: {
    airport: 10,
    bus: 10,
    ferry: 5,
    gas_station: 10,
    metro: 7,
    parking: 10,
    taxi: 10,
    train: 12,
    tram: 5,
  },
};

export default PLACES_PROFILE;
